<template lang="pug">
.buyVipWayPc
  .title.color_text_1(:class="{'isVipContent': orderType==0}") 支付方式
  .pay-way
    .pay-way_type(v-if="!currentPackage.auto")
      .type_wechat(
        :class="payWay === 'weixin' ? ['active', 'color_label_2', 'color_text_vip_2'] : 'color_text_2'"
        @click="changePayWay('weixin')"
      )
        .content
          img.icon(src="@/assets/imgs/vip/light/wechat.png")
          span.name 微信
        .arrow.color_label_2(v-if="payWay === 'weixin'")
      .type_alipay(
        :class="payWay === 'alipay' ? ['active', 'color_label_2', 'color_text_vip_2'] : 'color_text_2'"
        @click="changePayWay('alipay')"
      )
        .content
          img.icon(src="@/assets/imgs/vip/light/alipay.png")
          span.name 支付宝
        .arrow.color_label_2(v-if="payWay === 'alipay'")
    .pay-way_qrcode(:class="{'pay-way_qrcode_auto': currentPackage.auto}")
      .no-qrcode(v-if="useView === 'vip' && (!isLogin || (currentPackage.auto && vipInfo.auto))")
        .no-qrcode_login.color_text_2(@click="goToLogin" v-if="!isLogin") 点我购买
        .no-qrcode_auto.color_text_2(v-else) 已购买过
      .frequent(v-else-if="isFrequent" @click="getPayOrder")
        .frequent-qrcode.color_text_2
      .haved-qrcode(v-else @click="getPayOrder")
        img.qrcode(:src="qrCode.codePayUrl" v-if="payWay==='weixin' || (payWay == 'alipay' && currentPackage.auto)")
        iframe.qrcode.iframe(:src="qrCode.codePayUrl" frameborder="0" width="89.66" height="89.66" scrolling="no" v-if="payWay === 'alipay' && !currentPackage.auto")
      .price-content
        .price
          .pay_sum.color_text_1 支付金额：
          .price_num.color_vip_price
            span.unit ￥
            span.num {{currentPackage.price}}
        .price-content-pay_type.color_text_3(v-if="currentPackage.auto")
          img.icon(src="@/assets/imgs/vip/light/alipay.png")
          span.pay_type 使用支付宝扫码支付
        .desc.color_text_3 {{currentPackage.desc}}
        .regulation.color_text_3
          span 开通前阅读并同意
          span.service-agreement.color_text_2(@click="openServiceAgreement") 《会员服务协议》
          span.renewal.color_text_2(@click="openRenewalRule") 《自动续费规则》
        //- .tips.color_text_3 年卡购买成功后，请下载「有道翻译」客户端，进入「会员中心」-「我的福利」完成联合会员权益查看领取
</template>
<script>
import jrQrcode from 'jr-qrcode';
import service from '@/service/vip';

export default {
  name: 'buyVipWayPc',
  props: ['currentPackage', 'orderType', 'vipInfo', 'isLogin', 'useView', 'isSVip', 'isHaveWalfare'],
  data() {
    return {
      payWay: 'weixin', // 默认支付方式微信
      qrCode: { // 返回二维码信息
        orderId: '',
        codePayUrl: '',
      },
      timer: '',
      isSucceed: false,
      isFrequent: false,
      win: null, // origin 窗口
    };
  },
  mounted() {
    console.log('opener', window.opener);
    if (window.opener !== null) {
      this.win = window.opener;
    }
  },
  watch: {
    payWay: {
      handler() {
        this.getPayOrder();
      },
      deep: true,
    },
    currentPackage: {
      handler(val) {
        if (val.auto) {
          this.payWay = 'alipay';
        } else {
          this.payWay = 'weixin';
        }
        this.getPayOrder();
      },
      deep: true,
    },
    'qrCode.orderId': {
      handler(val) {
        this.getPayStatus(val);
      },
      deep: true,
    },
    '$route.query': {
      handler(val) {
        if (val.source) {
          this.source = val.source;
        } else if (val.keyfrom) {
          this.source = val.keyfrom;
        } else {
          this.source = this.isSVip ? 'web_renew_vip' : 'web_open_vip';
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 跳登录
    goToLogin() {
      window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${encodeURIComponent(window.location.href)}&t=${new Date().getTime()}`;
    },
    // 打开会员服务协议
    openServiceAgreement() {
      const url = 'https://c.youdao.com/dict/law/VIP.html';
      window.open(url);
    },
    // 打开自动续费规则
    openRenewalRule() {
      const url = 'https://c.youdao.com/dict/law/renew.html';
      window.open(url);
    },
    // 更换支付方式
    changePayWay(val) {
      this.payWay = val;
    },
    _rl_get_cookie(e) {
      const c = document.cookie;
      const g = `${e}=`;
      const d = c.length;
      let a = 0;
      while (a < d) {
        const f = a + g.length;
        if (c.substring(a, f) === g) {
          let b = c.indexOf(';', f);
          if (b === -1) {
            b = d;
          }
          return unescape(c.substring(f, b));
        }
        a = c.indexOf(' ', a) + 1;
        if (a === 0) {
          break;
        }
      }
      return -1;
    },
    // 获取预支付订单信息，生成支付二维码
    getPayOrder() {
      console.log('cookie', document.cookie);
      const ncoo = this._rl_get_cookie('OUTFOX_SEARCH_USER_ID_NCOO');
      const params = {
        imei: ncoo,
        keyfrom: 'webdict',
        apiversion: '1.0',
        paytype: this.payWay,
        platform: 'webdict',
        pid: this.currentPackage.planId,
        orderType: this.orderType, // 0为会员订单
        source: this.source,
      };
      service.getPayOrder(params).then((res) => {
        if (res.success) {
          this.isFrequent = false;
          this.qrCode.orderId = res.orderId;
          if (this.payWay === 'alipay' && !this.currentPackage.auto) {
            this.qrCode.codePayUrl = res.url;
            // this.qrCode.codePayUrl = jrQrcode.getQrBase64(res.url, {
            //   padding: 0,
            //   width: 128,
            //   height: 128,
            // });
          }
          if (this.payWay === 'weixin' || this.currentPackage.auto) {
            this.qrCode.codePayUrl = jrQrcode.getQrBase64(res.url, {
              padding: 0,
              width: 128,
              height: 128,
            });
          }
        } else if (res.errorCode === 2308) {
          this.isFrequent = true;
          this.$toast('操作频繁，请稍后重试');
        } else {
          console.log('其他操作');
        }
      });
    },
    // 获取订单支付状态
    getPayStatus(id) {
      const params = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        platform: 'webdict',
        orderid: id,
        orderType: this.orderType, // 0为会员订单
      };
      this.isSucceed = false; // 支付成功状态重置为false
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        service.getOrderStatus(params).then((res) => {
          if (res.success) {
            this.isSucceed = true;
            if (this.isHaveWalfare) {
              this.$toast('购买成功，可在页面下方【我的福利】中查看权益');
            } else {
              this.$toast('支付成功');
            }
            clearInterval(this.timer);
            setTimeout(() => {
              // 更新vip当前页面
              window.location.reload(true);
            }, 1000);
            if (this.win) {
              this.win.postMessage({ buyVipSuccess: true }, '*');
            }
          }
        });
      }, 1000);
    },
  },
};
</script>
<style lang="stylus" scoped>
.buyVipWayPc
  overflow hidden
  .title
    font-size 14px
    line-height 19px
    margin 3px 0 14px
    display inline-block
    position relative
    z-index 1
  .isVipContent
    margin-top 34px
  .pay-way
    height 120px
    display flex
    .pay-way_type
      .type_wechat, .type_alipay
        width 120px
        height 56px
        text-align center
        position relative
        .content
          display inline-block
          margin auto
          line-height 55px
          cursor pointer
          .name
            margin-left 10px
            vertical-align middle
            font-size 14px
          .icon
            width 16px
            height 16px
            vertical-align middle
        .arrow
          width 12px
          height 12px
          border-radius 2px
          transform rotate(45deg)
          position: absolute
          top 21px
          right -6px
      .active
        border-radius 8px
    .pay-way_qrcode
      margin-left 24.46px
      display flex
      justify-content: center
      align-items: center
      .price-content
        position relative
        top -7px
      .haved-qrcode
        cursor pointer
      .iframe
        pointer-events: none;
      .qrcode
        width 128px
        height 128px
        margin-right 13.46px
        cursor pointer
      .frequent-qrcode
        width 128px
        height 128px
        margin-right 24px
        font-size 12px
        text-align center
        line-height 128px
        cursor pointer
        background: url('./../assets/imgs/vip/light/refresh.png') 0 0 / 100% no-repeat
      .no-qrcode_login, .no-qrcode_auto
        width 128px
        height 128px
        margin-right 13.46px
        font-size 12px
        text-align center
        line-height 128px
        cursor pointer
        background: url('./../assets/imgs/vip/light/warnQrcode.png') 0 0 / 100% no-repeat
      .pay_sum, .price_num
        display inline-block
      .price_num
        font-family 'Gilroy-SemiBold'
      .unit
        font-size 14px
        line-height 20px
      .num
        font-size 26px
        line-height 31px
      .desc
        font-size 12px
        font-family: 'PingFang-SC-Regular'
        margin-top 7px
      .regulation
        font-size 12px
        line-height 17px
        font-family: 'PingFang-SC-Regular'
        margin-top 7px
        .service-agreement, .renewal
          cursor pointer
      .price-content-pay_type
        font-size 12px
        line-height: 12px
        .icon
          width 13px
          height 13px
          display inline-block
          vertical-align middle
          margin-right 2px
      .tips
        font-size 12px
        line-height 17px
        font-family: 'PingFang-SC-Regular'
        margin-top 7px
    .pay-way_qrcode_auto
      margin-left 0
</style>
